var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 197,
    height: 197,
    viewBox: "0 0 197 197",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1171275887"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user-circle-single--circle-geometric-human-person-single-user"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M98.5003 113.143C108.209 113.143 117.52 109.286 124.385 102.421C131.251 95.5558 135.107 86.2447 135.107 76.5359C135.107 66.827 131.251 57.5159 124.385 50.6507C117.52 43.7855 108.209 39.9287 98.5003 39.9287C88.7915 39.9287 79.4803 43.7855 72.6152 50.6507C65.75 57.5159 61.8932 66.827 61.8932 76.5359C61.8932 86.2447 65.75 95.5558 72.6152 102.421C79.4803 109.286 88.7915 113.143 98.5003 113.143Z",
    stroke: "#7F7F7F",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M35.9753 170.25C42.5096 159.524 51.6931 150.66 62.643 144.509C73.5929 138.358 85.9411 135.127 98.5003 135.127C111.06 135.127 123.408 138.358 134.358 144.509C145.308 150.66 154.491 159.524 161.025 170.25",
    stroke: "#7F7F7F",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M98.5004 193.679C123.743 193.679 147.952 183.651 165.802 165.802C183.651 147.952 193.679 123.743 193.679 98.5001C193.679 73.2572 183.651 49.0481 165.802 31.1987C147.952 13.3492 123.743 3.32153 98.5004 3.32153C73.2574 3.32153 49.0484 13.3492 31.1989 31.1987C13.3495 49.0481 3.32178 73.2572 3.32178 98.5001C3.32178 123.743 13.3495 147.952 31.1989 165.802C49.0484 183.651 73.2574 193.679 98.5004 193.679Z",
    stroke: "#7F7F7F",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProf);
export default __webpack_public_path__ + "static/media/prof.d77a88d7ad1c889430e3b9a6c6c3e5b6.svg";
export { ForwardRef as ReactComponent };